import { render, staticRenderFns } from "./ConfigStock.vue?vue&type=template&id=e598d160&"
import script from "./ConfigStock.vue?vue&type=script&lang=js&"
export * from "./ConfigStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports